import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export const useAliasAvailable = (accountID, showID) => (alias) => axios
    .get(`/api/${ accountID }/links/${ showID }/available/${alias}`)
    .then((res) => res.data)

export const useLinksPlacements = (accountID, showID) =>
    useQuery({
        queryKey: [accountID, showID, "links", "placements"],
        queryFn: () =>
            axios
                .get(`/api/${ accountID }/links/${ showID }`)
                .then((res) => res.data),
    });

export const useLinksPromotion = (accountID, showID, promotionID) =>
    useQuery({
        queryKey: [
            accountID,
            showID,
            "links",
            "promotions",
            promotionID,
        ],
        queryFn: () =>
            axios
                .get(`/api/${ accountID }/links/${ showID }/${ promotionID }`)
                .then((res) => res.data),
    });

export const useLinksDestinations = (accountID, showID, promotionID) =>
    useQuery({
        queryKey: [
            accountID,
            showID,
            "links",
            "promotions",
            promotionID,
            "destinations",
        ],
        queryFn: () =>
            axios
                .get(`/api/${ accountID }/links/${ showID }/${ promotionID }/destinations`)
                .then((res) => res.data),
    });

export const useLinksActivate = (accountID, showID) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (values) =>
            axios
                .post(
                    `/api/${ accountID }/links/${ showID }/activate`,
                    values
                )
                .then((res) => res.data),
        onSettled: () => {
            queryClient.refetchQueries([accountID, showID, "links"]);
        }
    });
};

export const useLinksUpdate = (accountID, showID, promotionID) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (values) =>
            axios
                .put(
                    `/api/${ accountID }/links/${ showID }/${ promotionID }`,
                    values
                )
                .then((res) => res.data),
        onSettled: () => {
            queryClient.refetchQueries([accountID, showID, "links"]);
        }
    });
};
